/**
 * Direct Password Set Modal — extracted from AdminDashboard.jsx.
 *
 * For the case where the email is broken and the admin needs to manually
 * set a user's password. The new password is held in parent state so the
 * parent can clear/forward it to the API.
 */
import React from 'react';
import { KeyRound } from 'lucide-react';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export function DirectPasswordModal({
  open,
  onOpenChange,
  user,
  newPassword,
  setNewPassword,
  isSubmitting,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <KeyRound className="h-5 w-5 text-green-500" />
            Set Password Directly
          </DialogTitle>
          <DialogDescription>
            Set a new password for <strong>{user?.email}</strong>
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="bg-yellow-50 dark:bg-yellow-950/30 p-3 rounded-lg text-sm text-yellow-800 dark:text-yellow-300">
            <p className="font-medium mb-1">Use this when email isn&apos;t working</p>
            <p className="text-yellow-700 dark:text-yellow-400">
              You&apos;ll need to securely share the new password with the user (e.g., via phone or in person).
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="direct-password">New Password</Label>
            <Input
              id="direct-password"
              type="text"
              placeholder="Enter new password (min 6 characters)"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="off"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            disabled={isSubmitting || newPassword.length < 6}
          >
            {isSubmitting ? 'Setting...' : 'Set Password'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DirectPasswordModal;
